import BordOneToneIcon, {
  IbordOneToneIconProps
} from '../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';

import './InfoDisplayItem.scss';

const InfoDisplayItem = ({
  text,
  value,
  dateCustomClassName,
  oneToneIconProps = {
    variant: 'calendar',
    standardSize: 16
  }
}: IInfoDisplayItem) => {
  const defaultClassName = dateCustomClassName ?? 'text-nudos-blue';
  return (
    <div className="infoDisplayItem">
      <div className="textStyles">{text}</div>
      <div className="iconValueRow">
        <BordOneToneIcon {...oneToneIconProps} />
        <div className={`dateStyles ${defaultClassName}`}>{value}</div>
      </div>
    </div>
  );
};

export default InfoDisplayItem;

interface IInfoDisplayItem {
  text?: string | JSX.Element;
  value?: string | JSX.Element;
  dateCustomClassName?: string;
  oneToneIconProps?: IbordOneToneIconProps;
}
